import Login from '@app/views/Login';
import { memo } from 'react';

export default memo(Login);
